import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class HeroMarqueeComponent extends Component {
  requiredRefs = ['track', 'set'];
  #io = null;

  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) {
      this.classList.add('is-visible');
      this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
      return;
    }
    this.#io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          this.classList.add('is-visible');
          this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
          this.#io?.disconnect();
        }
      }
    }, { rootMargin: '0px 0px -5% 0px' });
    this.#io.observe(this);
    this.#ensureClone();
  }

  updatedCallback() {
    super.updatedCallback?.();
    if (!prefersReducedMotion()) this.#ensureClone();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#io?.disconnect();
  }

  #ensureClone() {
    const { track, set } = this.refs;
    if (!track || !set) return;
    track.querySelectorAll('[data-hm-clone]').forEach((n) => n.remove());
    const clone = set.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-hm-clone', '');
    clone.removeAttribute('ref');
    track.appendChild(clone);
  }
}

if (!customElements.get('hero-marquee-component')) {
  customElements.define('hero-marquee-component', HeroMarqueeComponent);
}
